import { h, Fragment, Component } from "preact";
import { observer } from "mobx-react";
import { Tabs } from "../Tabs/Tabs";

import {
  ThemeProvider,
  LoadingBar,
  defaultTheme,
  StoreProvider,
  ControllerProvider,
} from "@searchspring/snap-preact-components";
import { Header } from "../Header/Header";
import { Results, NoResults } from "../Results/Results";
@observer
export class Content extends Component {

  render() {
    const store = this.props.tabs.active.controller.store;
    const PlaceholderSkeleton = () => (
      <div className="ss-results-left-column left-column-wrapper page-width plp-skeleton ss-skeleton">
        <div className="plp-skeleton-left">
          {[...Array(6)].map((_, index) => (
            <div key={index} className="place-item-nav"></div>
          ))}
        </div>
        <div className="ss__results plp-skeleton-right">
          {[...Array(3)].map((_, index) => (
            <article key={index} className="ss__result ss__result--grid ss__results__result plp-skeleton-item">
              <div className="ss__result-link">
                <div className="product-card-top-wrapper">
                  <div className="ss__result__image-wrapper">
                    <div className="ss__image ss__result__image ss-1pvonqc">
                      <div className="plp-skeleton-item-img">
                        <svg
                          className="w-10 h-10 text-gray-200 dark:text-gray-600"
                          aria-hidden="true"
                          xmlns="http://www.w3.org/2000/svg"
                          fill="currentColor"
                          viewBox="0 0 20 18"
                        >
                          <path d="M18 0H2a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2Zm-5.5 4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Zm4.376 10.481A1 1 0 0 1 16 15H4a1 1 0 0 1-.895-1.447l3.5-7A1 1 0 0 1 7.468 6a.965.965 0 0 1 .9.5l2.775 4.757 1.546-1.887a1 1 0 0 1 1.618.1l2.541 4a1 1 0 0 1 .028 1.011Z"></path>
                        </svg>
                      </div>
                    </div>
                  </div>
                  <div className="ss__result__details">
                    <div className="ss__result__details__title place-item place-item-3-col"></div>
                    <div className="ss__result__details__pricing place-item place-item-4-col"></div>
                    <div className="ss__result__details__review place-item place-item-2-col"></div>
                    <div className="flex-place">
                      <div className="ss__result__details__review place-item place-item-1-col"></div>
                      <div className="ss__result__details__review place-item place-item-1-col"></div>
                    </div>
                  </div>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    );
    return (
      <ControllerProvider controller={ this.props.tabs.active.controller}>
        <ThemeProvider theme={defaultTheme}>
          <StoreProvider store={store}>
            <div>
                {store.pagination.totalResults > 0 ? (
                  <>
                    <Header tabs={this.props.tabs} />
                    <Results />
                  </>
                ) : store.pagination.totalResults === 0 ? (
                  <NoResults />
                ) : (
                  <PlaceholderSkeleton />
                )}
            </div>
          </StoreProvider>
        </ThemeProvider>
      </ControllerProvider> 
    );
  }
}
